import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/lib/auth';
import { useTranslation } from '@/lib/i18n';
import { ApprovalTray } from './-components/content/ApprovalTray';
import { MyRequestsTray } from './-components/content/MyRequestTray';
import { MyTasksTray } from './-components/content/MyTaskTray';
import { RequestSection } from './-components/content/RequestSection';
export const Route = createFileRoute('/_individual/individual/')({
  component: () => <Overview />
});
const Overview = () => {
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'individualPages.home'
  });
  const {
    session
  } = useAuthStore();
  const userName = session?.person.name || '';
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();

  // 時間帯に応じた挨拶
  const greeting = useMemo(() => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return t('greeting.morning');
    }
    if (hour < 18) {
      return t('greeting.afternoon');
    }
    return t('greeting.evening');
  }, [t]);
  return <VStack className="h-full w-full items-center overflow-y-auto">
      {/* Header with greeting and trays */}
      {/* shrink-0: 親が h-full の flex column のため、指定しないと overflow-hidden を
          持つこのヘッダーが縮んで中身が見切れる */}
      <div className="w-full shrink-0 bg-[#7ab5dd] px-5 lg:px-20 py-10 pb-14 shadow-md relative overflow-hidden">
        <img src="/images/portal_background.png" alt="Portal Background" className="absolute top-1/3 left-1/2 -translate-x-1/2 w-auto opacity-70" />
        <VStack className="gap-10 justify-center items-center w-full max-w-dialog-xl mx-auto relative z-10">
          {/* Greeting */}
          {isDesktop ? <div className="flex items-center justify-center gap-4 w-full">
              <Text as="h1" variant="h1" className="capitalize text-center">
                {greeting}, {t('name', {
              name: userName
            })}
              </Text>
            </div> : <VStack className="gap-1 w-full">
              <Text as="h1" variant="h2" className="capitalize">
                {greeting}
              </Text>
              <Text as="h1" variant="h2">
                {t('name', {
              name: userName
            })}
              </Text>
            </VStack>}

          {/* Trays */}
          <VStack className="gap-6 w-full">
            <MyTasksTray />
            <ApprovalTray />
            <MyRequestsTray />
          </VStack>
        </VStack>
      </div>

      {/* Main Content */}
      <VStack className="gap-6 w-full shrink-0 max-w-[1080px] mx-auto px-5 lg:px-20 py-14">
        <RequestSection />
      </VStack>
    </VStack>;
};